if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.tab-buttons a').click(function(e){
        e.preventDefault();
        $('.tab-buttons a').removeClass('active');
        $(this).addClass('active');
        var selectedTab = $(this).attr('href');
        $(selectedTab).siblings('.tab-wrapper').removeClass('active');
        $(selectedTab).addClass('active');
        $(".tab-wrapper .sym-slides").slick("unslick");
        $(".tab-wrapper .sym-slides").slick({
          accessibility: false,
        });
    });
    $(".filter a").click(function (e) {
      e.preventDefault();
      var filterArea = $(this).closest(".filter").attr("data-filter-section");
      var filterby = $(this).attr("data-filter");
      $(".filter .btn").removeClass("active");
      $(this).addClass("active");
      if (filterby == "all") {
        $(".filter-block").show();
        $(".filter-block .animate-fade").addClass("fade-in visible");
      } else {
        var selectedBlocks = $("#" + filterArea).children(
          ".filter-block[data-filter*='" + filterby + "']"
        );
        $("#" + filterArea)
          .children(".filter-block[data-filter*='" + filterby + "']")
          .remove();
        $(".filter-block").hide();
        $(selectedBlocks).prependTo("#" + filterArea);
        $("#" + filterArea)
          .children(".filter-block[data-filter*='" + filterby + "']")
          .show();
        $("#" + filterArea)
          .children(".filter-block[data-filter*='" + filterby + "']")
          .find(".animate-fade")
          .addClass("fade-in visible");
      }
      $(".filter-block .sym-slides").slick("unslick");
      $(".filter-block .sym-slides").slick({
        accessibility: false,
      });
    });
    $('.sym-slides').slick({
        accessibility: false
    });


    // scroll anchor link
    $('.scroll-link').click(function () {
      var target = $(this).attr("href");
      $('html, body').animate({scrollTop: $(target).offset().top - 120}, 1000);
      return false;
    });


    // RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});

    /* Progress Bar Sliders  */
		var $slider = $('.sym-slides-text');
		var $progressBar = $('.progress');
		var $progressBarLabel = $( '.slider__label' );
		let ITEMS_SLIDE = document.querySelector('.sym-slides-text .slick-track').childElementCount

		const firstElement = (items) => {
			let ACTUAL_CALC = ( (1) / (items) ) * 100

			$progressBar
				.css('background-size', `${ACTUAL_CALC}% 100% `)
				.attr('aria-valuenow', ACTUAL_CALC );

			$progressBarLabel.text( `${ACTUAL_CALC}% completed` );
		}

		firstElement(ITEMS_SLIDE)

		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;

			$progressBar
			.css('background-size', calc + '% 100%')
			.attr('aria-valuenow', calc );

			$progressBarLabel.text( calc + '% completed' );
		});

		// Map: Return to previous page button. Change body id to match map template's name.

})();



/* READY ! */
document.addEventListener('DOMContentLoaded', () => {

  // Get the sticky element
  const stickyEl = document.querySelector('.universal-studios-orlando-partner-hotel .sub-menu'),
    observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
      { threshold: [1] }
    )

  stickyEl && observer.observe(stickyEl)

})